import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-asoproject-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add ASO Project ")
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "UPDATE REPORT", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "EDIT", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "DELETE", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddAsoProjectModal = _resolveComponent("AddAsoProjectModal")!
  const _component_UpdateAsoReportModal = _resolveComponent("UpdateAsoReportModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_asoProject",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSelectedItem(null)))
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
              ]),
              _hoisted_7
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.myAsoProjects,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true
        }, {
          "cell-name": _withCtx(({ row: asoproject }) => [
            _createTextVNode(_toDisplayString(asoproject.name), 1)
          ]),
          "cell-client": _withCtx(({ row: asoproject }) => [
            _createTextVNode(_toDisplayString(asoproject.client.name), 1)
          ]),
          "cell-os": _withCtx(({ row: asoproject }) => [
            _createTextVNode(_toDisplayString(asoproject.os), 1)
          ]),
          "cell-update": _withCtx(({ row: asoproject }) => [
            _createElementVNode("button", {
              type: "button",
              class: "el-button el-button--primary is-round el-button--mini",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_update_aso_report",
              onClick: ($event: any) => (_ctx.setSelectedItem(asoproject))
            }, _hoisted_11, 8, _hoisted_9)
          ]),
          "cell-actions": _withCtx(({ row: asoproject }) => [
            _createElementVNode("button", {
              type: "button",
              class: "el-button el-button--success is-round el-button--mini",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_add_asoProject",
              onClick: ($event: any) => (_ctx.setSelectedItem(asoproject))
            }, _hoisted_14, 8, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              class: "el-button el-button--danger is-round el-button--mini",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_delete",
              onClick: ($event: any) => (_ctx.setSelectedItem(asoproject))
            }, _hoisted_17, 8, _hoisted_15)
          ]),
          _: 1
        }, 8, ["table-data", "table-header"])
      ])
    ]),
    _createVNode(_component_AddAsoProjectModal, { asoproject: _ctx.selectedItem }, null, 8, ["asoproject"]),
    _createVNode(_component_UpdateAsoReportModal, { asoproject: _ctx.selectedItem }, null, 8, ["asoproject"]),
    _createVNode(_component_DeleteModal, {
      item: _ctx.selectedItem,
      model: "ASO Project",
      endpoint: "asoprojects"
    }, null, 8, ["item"])
  ], 64))
}